<template>
  <div v-if="publicToken !== null && getContactForm === true" class="rp-cart-form">
    <v-style>
      .rp-cart-form .vue-consent-container a {
        color: {{ color.link }} !important;
      }
    </v-style>

    <div v-if="contactForm.fields.length > 0">
      <div v-for="item in contactForm.fields" v-bind:key="item.id">
        <div class="form-label">
          <span v-if="item.label === 'Firstname'">
            {{ t.labelFirstname }}
          </span>
          <span v-else-if="item.label === 'Lastname'">
            {{ t.labelLastname }}
          </span>
          <span v-else-if="item.label === 'Email'">
            {{ t.labelEmail }}
          </span>
          <span v-else-if="item.label === 'Tel.'">
            {{ t.labelTel }}
          </span>
          <span v-else>
            {{ item.label }}
          </span>
          <span v-if="item.required === '1'" class="rp-required-symbol">
            *
          </span>
        </div>
        <div class="form-input" v-if="item.type === 'text' || item.type === 'email' || item.type === 'tel'">
          <text-input v-bind:ref="'formInput' + item.id" v-model="fieldValues[item.id]" v-bind:inputData="item"></text-input>
        </div>
        <div class="form-input" v-if="item.type === 'dropdown'">
          <dropdown-input v-bind:ref="'formInput' + item.id" v-model="fieldValues[item.id]" v-bind:inputData="item"></dropdown-input>
        </div>
        <div class="form-input" v-if="item.type === 'radio'">
          <radio-input v-bind:ref="'formInput' + item.id" v-model="fieldValues[item.id]" v-bind:inputData="item"></radio-input>
        </div>
        <div class="form-input" v-if="item.type === 'checkbox'">
          <checkbox-input v-bind:ref="'formInput' + item.id" v-model="fieldValues[item.id]" v-bind:inputData="item"></checkbox-input>
        </div>
        <div class="form-input" v-if="item.type === 'textarea'">
          <textarea-input v-bind:ref="'formInput' + item.id" v-model="fieldValues[item.id]" v-bind:inputData="item"></textarea-input>
        </div>
        <div class="form-input" v-if="item.type === 'attachment'">
          <file-input v-bind:ref="'formInput' + item.id" v-bind:inputData="item" v-bind:formData="contactForm.form.contact_attachment_allowed_file"></file-input>
        </div>
        <div class="form-input" v-if="item.type === 'datetime' || item.type === 'date'">
          <datetime-input v-bind:ref="'formInput' + item.id" v-model="fieldValues[item.id]" v-bind:inputData="item"></datetime-input>
        </div>
        <br />
      </div>
      <div v-if="system==='ShopShappy'" v-html="consent.value" id="vue-consent-container" class="cart-form vue-consent-container shappy-consent">
      </div>
      <div class="form-submit-button" v-if="hideContactButton !== 1">
        <div v-if="formValidation.result === false" class="rp-validation-failed-message rp-buttons is-center">
          {{ t.pleaseFillContactFormCompletely }}
        </div>
        <div class="rp-buttons is-center">
          <div v-if="loading.submitButton === true" class="rp-icon">
            <i class="fa fa-spinner fa-spin fa-2x"></i>
          </div>
          <a v-else
            class="rp-button"
            v-on:click="submitContactForm()"
            v-bind:style="{
              backgroundColor: color.secondaryMain,
              color: color.secondarySub,
              borderColor: color.secondaryMain,
              fontFamily: globalFont
            }">
            <template v-if="contactForm.form.contact_button_icon !== '' && contactForm.form.contact_button_icon !== null">
              <span class="rp-icon">
                <i v-bind:class="'fa ' + contactForm.form.contact_button_icon"></i>
              </span>
            </template>

            <span v-if="contactForm.form.contact_button_id === '-1'">
              {{ contactForm.form.contact_button_custom_text }}
            </span>
            <span v-else>
              <span v-if="locale == 'en'">
                {{ contactForm.form.contact_button_text_en }}
              </span>
              <span v-else-if="locale == 'vi'">
                {{ contactForm.form.contact_button_text_vi }}
              </span>
              <span v-else>
                {{ contactForm.form.contact_button_text_th }}
              </span>
            </span>
          </a>
        </div>
        <div v-html="consent.value" id='vue-consent-container' class="cart-form vue-consent-container">
        </div>
      </div>

      <div class="rp-modal rp-remove-modal" v-bind:class="{ 'is-active': modals.thankyou }">
        <div class="rp-modal-background" v-on:click="closeModal('thankyou')"></div>
        <div class="rp-modal-content rp-box">
          <div class="is-fluid thankyou-modal-container">
            <div>
              <span v-if="formSubmit.result === true" class="rp-icon">
                <i class="fa fa-check-circle fa-4x"></i>
              </span>
              <span v-else class="rp-icon">
                <i class="fa fa-times-circle fa-4x"></i>
              </span>
            </div>
            <br />
            <div v-if="formSubmit.result === true" class="thankyou-modal-text">{{ t.formSubmitThankyou }}</div>
            <div v-else class="thankyou-modal-text">{{ t.formSubmitError }}</div>
          </div>
        </div>
        <button class="rp-modal-close is-large" v-on:click="closeModal('thankyou')" aria-label="close"></button>
      </div>
    </div>
    <policy-popup/>
  </div>
</template>

<script>
import { Cart } from '@/store/Cart'
import CartButton from '@/components/CartButton'
import TextInput from '@/components/share/form/TextInput'
import DropdownInput from '@/components/share/form/DropdownInput'
import RadioInput from '@/components/share/form/RadioInput'
import CheckboxInput from '@/components/share/form/CheckboxInput'
import TextareaInput from '@/components/share/form/TextareaInput'
import FileInput from '@/components/share/form/FileInput'
import DatetimeInput from '@/components/share/form/DatetimeInput'
import PolicyPopup from '@/components/policyPopup/PolicyPopup'
export default {
  name: 'CartForm',
  components: {
    CartButton,
    TextInput,
    DropdownInput,
    RadioInput,
    CheckboxInput,
    TextareaInput,
    FileInput,
    DatetimeInput,
    PolicyPopup
  },
  props: {
    productSku: {
      type: [String, Number],
      default: null
    },
    productQuantity: {
      type: Number,
      default: 1
    },
    productVariantSelected: {
      type: Number,
      default: 1
    },
    hideContactButton: {
      type: [String, Number],
      default: 0
    }
  },
  data: () => {
    return {
      product: {
        quantity: 1
      },
      modals: {
        thankyou: false
      },
      formSubmit: {
        result: false
      },
      formValidation: {
        result: true
      },
      fieldValues: {},
      formData: new FormData(),
      loading: {
        submitButton: false
      },
      date: new Date(),
      options: {
        format: 'DD/MM/YYYY HH:mm',
        useCurrent: false,
        showClear: true,
        showClose: true
      },
      isSetListener: false
    }
  },
  computed: {
    t () {
      if (Cart.getLocale() == 'en') {
        return {
          formSubmitThankyou: 'Thank you',
          formSubmitError: 'Error occured',
          submitButtonContact: 'Contact',
          submitButtonReserve: 'Reserve',
          submitButtonBuyNow: 'Buy now',
          labelFirstname: 'Firstname',
          labelLastname: 'Lastname',
          labelEmail: 'Email',
          labelTel: 'Tel.',
          alertPleaseSelectVariants: 'Please select a product variants',
          pleaseFillContactFormCompletely: 'Please fill the form completely',
          pleaseSelectQuantityMoreThenZero: 'Please select a product quantity more than 0'
        }
      } else if (Cart.getLocale() == 'th') {
        return {
          formSubmitThankyou: 'ได้รับข้อมูลเรียบร้อยแล้ว',
          formSubmitError: 'เกิดข้อผิดพลาด',
          submitButtonContact: 'ติดต่อ',
          submitButtonReserve: 'จอง',
          submitButtonBuyNow: 'สั่งซื้อ',
          labelFirstname: 'ชื่อ',
          labelLastname: 'นามสกุล',
          labelEmail: 'อีเมล',
          labelTel: 'เบอร์ติดต่อ',
          alertPleaseSelectVariants: 'กรุณาเลือกตัวเลือกย่อยของสินค้า',
          pleaseFillContactFormCompletely: 'กรุณากรอกข้อมูลให้ครบถ้วน',
          pleaseSelectQuantityMoreThenZero: 'กรุณาเลือกจำนวนของสินค้าให้มากกว่า 0'
        }
      } else if (Cart.getLocale() == 'vi') {
        return {
          formSubmitThankyou: 'Cảm ơn',
          formSubmitError: 'Có lỗi xảy ra',
          submitButtonContact: 'Liên hệ',
          submitButtonReserve: 'Đặt trước',
          submitButtonBuyNow: 'Mua ngay',
          labelFirstname: 'Tên',
          labelLastname: 'Họ',
          labelEmail: 'Email',
          labelTel: 'Sđt',
          alertPleaseSelectVariants: 'Vui lòng chọn thuộc tính sản phẩm',
          pleaseFillContactFormCompletely: 'Vui lỏng nhập đầy đủ thông tin',
          pleaseSelectQuantityMoreThenZero: 'Vui lòng chọn số lượng sản phẩm lớn hơn 0'
        }
      }
    },
    totalProductQuantity () {
      return Cart.totalProductQuantity
    },
    color () {
      return Cart.getColor()
    },
    globalFont () {
      return Cart.getGlobalFont()
    },
    publicToken () {
      return Cart.token.public
    },
    getContactForm () {
      Cart.getContactForm()

      return true
    },
    contactForm () {
      this.initFieldValues()

      return Cart.contactForm
    },
    locale () {
      return Cart.getLocale()
    },
    consent () {
      return Cart.getConsent()
    },
    system () {
      return Cart.getSystem()
    },
    multiLanguageId () {
      return Cart.getMultiLanguage()
    },
    getShappy () {
      return Cart.getShappy()
    }
  },
  methods: {
    closeModal (modal) {
      this.modals[modal] = false
    },
    initFieldValues () {
      Cart.contactForm.fields.forEach((item, index) => {
        if (item.type === 'checkbox') {
          this.$set(this.fieldValues, item.id, [])
        } else {
          this.$set(this.fieldValues, item.id, '')
        }
      })
    },
    clearFieldAttachmentValues () {
      Cart.contactForm.fields.forEach((item, index) => {
        if (item.type === 'attachment') {
          this.$refs['formInput' + item.id][0].clearFile()
        }
      })
    },
    generateFormData () {
      return new Promise((resolve, reject) => {
        this.formData = new FormData()
        this.getFiles()

        this.formData.append('velaeasy_domain', Cart.getVelaeasyDomain())
        this.formData.append('product_sku', this.productSku)
        this.formData.append('product_quantity', this.productQuantity)
        this.formData.append('languageId', this.multiLanguageId)

        this.contactForm.fields.forEach((item, index) => {
          this.formData.append('field_id[]', item.id)

          if (item.type === 'checkbox') {
            this.fieldValues[item.id].forEach((item2, index2) => {
              this.formData.append(`field_value_${item.id}[]`, item2)
            })
          } else {
            this.formData.append(`field_value_${item.id}`, this.fieldValues[item.id])
          }
        })

        this.formData.append('language', Cart.getLocale())
        this.formData.append('gclid', Cart.getGclId())

        Cart.getMemberToken().then(result => {
          this.formData.append('member_id', result.member_id)
          this.formData.append('member_token', result.member_token)

          resolve()
        })

        if (this.system === 'ShopShappy') {
          this.formData.append('channel_name', this.getShappy.channelName)
        }
      })
    },
    submitContactForm () {
      if (this.productQuantity < 1) {
        alert(this.t.pleaseSelectQuantityMoreThenZero)
      } else {
        if (this.productVariantSelected === 1) {
          this.loading.submitButton = true

          if (this.validateContactForm() === true) {
            Cart.submitContactForm.loading = true
            this.generateFormData().then(result => {
              Cart.submitContactFormAPI(this.formData).then(result => {
                if (result === true) {
                  this.formSubmit.result = true
                  this.initFieldValues()
                  this.clearFieldAttachmentValues()
                } else {
                  this.formSubmit.result = false
                }
                this.modals.thankyou = true
                this.loading.submitButton = false
                Cart.submitContactForm.loading = false
              })
            })
          } else {
            this.loading.submitButton = false
          }
        } else {
          alert(this.t.alertPleaseSelectVariants)
        }
      }
    },
    validateContactForm () {
      let result = true

      this.contactForm.fields.forEach((item, index) => {
        if (this.$refs['formInput' + item.id][0].validateInput() === false) {
          result = false
        }
      })

      this.formValidation.result = result

      return result
    },
    getFiles () {
      this.contactForm.fields.forEach((item, index) => {
        if (item.type === 'attachment') {
          this.formData.append(
            `attachment_value_${item.id}`,
            this.$refs['formInput' + item.id][0].getFiles()
          )
        }
      })
    },
    closePolicyPopup () {
      this.openPolicyPopup = false
    }
  },
  watch: {
    consent: function(value) {
      setTimeout(() => {
        const consent = document.querySelector('.cart-form.vue-consent-container #consent-container a#vue-popup-policy')
        if (consent) {
          consent.addEventListener('click', function () {
            Cart.$emit('openPolicyPopup', 'cart-form')
          })
          this.isSetListener = true
        }
      }, 200)
    }
  },
  created () {
    Cart.$off('ContactFormSubmit')
    Cart.$on('ContactFormSubmit', () => {
      this.submitContactForm()
    })
  },
  mounted () {
    Cart.getConsentApi('cartForm')
  }
}
</script>

<style lang="scss">
  #vue-consent-container #consent-container a#vue-popup-policy {
    white-space: nowrap;
  }
  .cart-form.shappy-consent #consent-container a{
    color: #3273dc;
  }

  .rp-cart-form {
    .vue-consent-container {
      #consent-container {
        margin: 20px 20px;
      }
    }
  }
</style>

<style lang="scss" scoped>
.vue-consent-container {
  line-height: 1.5;
  display: flex;
  justify-content: center;
  text-align: center;
  font-size: 0.8em;
}
div .rp-button {
  margin: 16px 0px;
}
.form-label {
  margin-bottom: 5px;
}

.rp-required-symbol,
.rp-validation-failed-message {
  color: red;
}

.rp-modal {
  .rp-modal-content {
    width: 400px;
    padding-top: 40px;
  }

  .thankyou-modal-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    .fa-check-circle {
      color: green;
    }

    .fa-times-circle {
      color: red;
    }

    .thankyou-modal-text {
      font-size: 32px;
    }
  }

  .rp-modal-close {
    background-color: transparent !important;
  }
}
@media screen and (max-width: 768px) {
  .rp-modal {
    .thankyou-modal-container {
      .thankyou-modal-text {
        font-size: 22px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cartForm/index.vue